export interface EmailSignature {
  id: string
  name: string
  bodyHtml: string
  isDefault: boolean
  createdBy: string
  createdAt: string
  updatedBy?: string
  updatedAt?: string
}

export interface EmailSignatureCreatePayload {
  name: string
  bodyHtml: string
  isDefault?: boolean
}

export interface EmailSignatureUpdatePayload {
  name?: string
  bodyHtml?: string
  isDefault?: boolean
}

export const SIGNATURE_WRAPPER_CLASS = 'email-signature'
